import Dialog from "../Dialog/Dialog";
import React from "react";
import { Typography } from "@mui/material";

type ConfirmationDialogProps = {
  title: string;
  text: string;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  text,
  isOpen,
  onClose,
  onSubmit,
}) => {
  const submitAndClose = () => {
    onSubmit();
    onClose();
  };
  return (
    <Dialog
      title={title}
      open={isOpen}
      onSubmit={submitAndClose}
      onClose={onClose}
      isSubmitEnabled={true}
      customWidth="sm"
    >
      <Typography paddingBottom={"20px"} paddingTop={"20px"}>
        {text}
      </Typography>
    </Dialog>
  );
};

export default ConfirmationDialog;
